<div class="setup-step">
  @if (pageState() === 'verifying') {
  <div class="connect-intune__state d-flex flex-column align-items-center justify-content-center text-center py-5 gap-3">
    <mat-spinner diameter="40"></mat-spinner>
    <p class="text-body-secondary mb-0">{{ 'onboarding.setup.connectIntune.loading' | translate }}</p>
  </div>
  }

  @if (pageState() === 'error_consent') {
  <div class="connect-intune__state d-flex flex-column align-items-center justify-content-center text-center py-5 gap-3">
    <mat-icon class="connect-intune__state-icon--error icon-lg">gpp_bad</mat-icon>
    <h2 class="fs-5 fw-bold text-body mb-0">
      {{ 'onboarding.setup.connectIntune.consentFailedTitle' | translate }}
    </h2>
    <p class="text-body-secondary mb-0">{{ errorMessage() }}</p>
    <div class="d-flex gap-3">
      <button mat-stroked-button class="px-4 rounded-full" (click)="onBack()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'onboarding.setup.connectIntune.back' | translate }}
      </button>
      <button mat-flat-button color="primary" class="px-4 rounded-full" (click)="onGrantConsent()">
        <mat-icon>refresh</mat-icon>
        {{ 'onboarding.setup.connectIntune.tryAgain' | translate }}
      </button>
    </div>
  </div>
  }

  @if (pageState() === 'ready') {
  <div class="text-center my-2 setup-step__header">
    <h1 class="mb-1">{{ 'onboarding.setup.connectIntune.title' | translate }}</h1>
    <p class="m-0">{{ 'onboarding.setup.connectIntune.subtitle' | translate }}</p>
  </div>

  <div class="permissions-grid">
    @for (permission of requiredPermissions; track permission) {
    <div
      class="av-permission d-flex align-items-center gap-2"
      [class.av-permission--granted]="consentGranted()"
    >
      <mat-icon class="av-permission__icon icon-sm">
        @if (consentGranted()) { check_circle } @else { lock }
      </mat-icon>
      <span
        class="small flex-fill text-start"
        [matTooltip]="permission"
        matTooltipPosition="above"
        >{{ permission.length > 25 ? (permission | slice: 0:25) + '...' : permission }}</span
      >
      <mat-icon
        class="av-permission__hint icon-sm"
        [matTooltip]="permissionTooltip(permission)"
        matTooltipPosition="above"
        >info</mat-icon
      >
    </div>
    }
  </div>

  @if (consentGranted()) {
  <div class="av-alert av-alert--success d-flex align-items-center gap-2 mt-3">
    <mat-icon>check_circle</mat-icon>
    <span class="fw-semibold">{{ 'onboarding.setup.connectIntune.consentGranted' | translate }}</span>
  </div>
  } @else {
  <div class="av-info-box d-flex align-items-start gap-3 mt-3">
    <mat-icon class="av-info-box__icon icon-md">info</mat-icon>
    <p class="small mb-0">
      {{ 'onboarding.setup.connectIntune.infoBoxPart1' | translate
      }}<strong>{{ 'onboarding.setup.connectIntune.infoBoxRole' | translate }}</strong
      >{{ 'onboarding.setup.connectIntune.infoBoxPart2' | translate }}
    </p>
  </div>
  }

  <div class="connect-intune__actions d-flex justify-content-between align-items-start gap-3 mt-4">
    <button mat-stroked-button class="px-4 rounded-full" (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
      {{ 'onboarding.setup.connectIntune.back' | translate }}
    </button>

    <div class="d-flex flex-column align-items-end gap-2">
      @if (consentGranted()) {
      <button mat-flat-button color="primary" class="px-4 rounded-full" (click)="onContinue()">
        <mat-icon>arrow_forward</mat-icon>
        {{ 'onboarding.setup.connectIntune.proceedToPayment' | translate }}
      </button>
      <p class="connect-intune__grant-hint mb-0">
        {{ 'onboarding.setup.connectIntune.proceedHint' | translate }}
      </p>
      } @else { @if (isConsentLoading()) {
      <button mat-flat-button color="primary" disabled class="px-4 rounded-full">
        <mat-spinner diameter="20" class="d-inline-block me-2"></mat-spinner>
        {{ 'onboarding.setup.connectIntune.redirecting' | translate }}
      </button>
      } @else {
      <button mat-flat-button color="primary" class="px-4 rounded-full" (click)="onGrantConsent()">
        <mat-icon>shield</mat-icon>
        {{ 'onboarding.setup.connectIntune.grantConsent' | translate }}
      </button>
      }
      <p class="connect-intune__grant-hint mb-0">
        {{ 'onboarding.setup.connectIntune.grantHint' | translate }}
      </p>
      }

      @if (errorMessage()) {
      <div class="av-alert av-alert--error d-flex align-items-center gap-2">
        <mat-icon>error</mat-icon>
        <span class="small">{{ errorMessage() }}</span>
      </div>
      }
    </div>
  </div>
  }
</div>
